package one.devsbox.commons

import kotlinx.serialization.json.Json
import kotlinx.serialization.protobuf.ProtoBuf

val JSON_INSTANCE by lazy {
    Json {
        ignoreUnknownKeys = true
        coerceInputValues = true
        encodeDefaults = true
        prettyPrint = false
        isLenient = true
        classDiscriminator = "polymorphic"
    }
}

val PROTO_INSTANCE by lazy {
    ProtoBuf {
        encodeDefaults = true
    }
}
